export function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" aria-label="Loading">
      <div className="flex flex-col items-center gap-4">
        <div className="w-10 h-10 rounded-full border-4 border-brand-200 border-t-brand-600 animate-spin" role="status" aria-label="Loading" />
        <p className="text-sm text-slate-500">Loading…</p>
      </div>
    </div>
  )
}
